var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.data.project)?_c('Residentials',_vm._b({staticClass:"kpb-residentials",attrs:{"filter":_vm.filter,"project":_vm.data.project,"properties":_vm.properties}},'Residentials',_vm.$attrs,false)):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }